module.exports = __webpack_public_path__ + "static/media/spin.0057ff06.svg";